module.exports = __webpack_public_path__ + "img/SLIDERS.e568bcbb.svg";